export const AuthenticationStep = {
	IDLE: -1,
	SIGN_UP: 0,
	LOGIN: 1,
	ENTER_PHONE: 2,
	VERIFY_PHONE: 3,
	ACTIVATE: 4,
	AUTHENTICATED: 5
}